var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "form-item conditions",
          class: [_vm.item.data.htmloptions, { "is-invalid": _vm.isInvalid }],
        },
        [
          _vm.item.data.question != ""
            ? _c("Label", {
                attrs: {
                  item: _vm.item,
                  "is-invalid": _vm.isInvalid,
                  errors: _vm.errors,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "checkbox-item" }, [
            _c("div", {
              staticClass: "text",
              domProps: { innerHTML: _vm._s(_vm.item.data.textBox) },
            }),
            _vm._v(" "),
            _c("input", {
              attrs: {
                id: _vm.item.data.id,
                type: "checkbox",
                name: _vm.item.data.id,
                value: "1",
              },
            }),
            _vm._v(" "),
            _c("i", { staticClass: "icon-form-checkmark" }),
          ]),
          _vm._v(" "),
          _vm.errorMessage
            ? _c("error-message", [_vm._v(_vm._s(_vm.errorMessage))])
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }